import { render } from "./SoundBtn.vue?vue&type=template&id=c605d22a"
import script from "./SoundBtn.vue?vue&type=script&lang=js"
export * from "./SoundBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__